export enum OnboardingStepName {
  CONNECT_STORE = 'connect_store',
  ADD_PRODUCT = 'add_product',
  ADD_COMPANY_INFO = 'add_company_info',
  ADD_CREDIT_CARD = 'add_credit_card',
  PLACE_FIRST_ORDER = 'place_first_order',
}
